module.exports = "<div mat-dialog-content style=\"text-align: center\">\r\n    <p>Customer is successfully added</p>\r\n</div>"